module.exports = __webpack_public_path__ + "assets/01.e0827d3b.pdf";